var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "v-stepper-step",
        {
          attrs: {
            complete: _vm.step > 1,
            step: "1"
          }
        },
        [_vm._v(" Redeem Promotion ")]
      ),
      _c(
        "v-stepper-content",
        {
          attrs: {
            step: "1"
          }
        },
        [
          _c(
            _vm.promoComponent,
            {
              tag: "component",
              on: {
                "service-selected": _vm.nextStep
              }
            },
            [_vm._v(" Unspecified promo type ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }